import AppHeader from './components/Header.vue';
import AnnouncementPopup from './components/AnnouncementPopup.vue';
import ApiFaultNotice from './components/ApiFaultNotice.vue';
import AppFooter from './components/Footer.vue';
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import { navigating } from './router';
export default {
  components: {
    AppHeader,
    AppFooter,
    AnnouncementPopup,
    ApiFaultNotice
  },
  name: 'App',
  setup() {
    const route = useRoute(),
      arriving = ref(false);
    watch(() => route.fullPath, () => {
      arriving.value = true;
    }, {
      flush: 'post'
    });
    return {
      navigating,
      arriving,
      isHome: computed(() => route.path === '/')
    };
  }
};